import { Injectable } from '@angular/core';
import { AuthHttp } from './auth.http';
import { ConfigStore } from '../stores/config.store';

@Injectable()
export class ResidentialService {

    constructor(private http: AuthHttp, private config: ConfigStore) { }

    property(id: string): any {

        let baseUrl: string = this.config.getValue('webServiceURL');
        let url: string = baseUrl + '/api/residenziali/' + id;

        return this.http.get(
            url
        ).map(response => {

            let json = response.json();

            // console.log('[ResidentialService] property | json:');
            // console.log(json);

            return json;
        }).share();
    }
}


// WEBPACK FOOTER //
// ./src/services/residential.service.ts